unit View.Lancamentos.Edit;

interface

uses
  System.SysUtils, System.Classes, WEBLib.Graphics, WEBLib.Forms, WEBLib.Dialogs,
  Vcl.Controls, Vcl.StdCtrls, WEBLib.StdCtrls,

  Bcl.Rtti.Common, XData.Web.Client, Data.DB, WEBLib.CDS,
  WEBLib.DBCtrls, XData.Web.JsonDataset, XData.Web.Dataset, JS,

  App.Types, Crud.Utils, WEBLib.DB, WEBLib.Controls, WEBLib.ExtCtrls;

type
  TFViewLancamentosEdit = class(TForm)
    pnlMessage: TPanel;
    lbMessage: TLabel;
    btCloseMessage: TButton;
    DataSource: TDatasource;
    btCancel: TButton;
    btSave: TButton;
    btDelete: TButton;
    lbid: TLabel;
    edid: TDBEdit;
    lbaliado_id: TLabel;
    edaliado_id: TDBEdit;
    lbdata_base_id: TLabel;
    eddata_base_id: TDBEdit;
    lbcliente_id: TLabel;
    edcliente_id: TDBEdit;
    lbfornecedor_id: TLabel;
    edfornecedor_id: TDBEdit;
    lbmodalidade_id: TLabel;
    edmodalidade_id: TDBEdit;
    lbplano_contas_id: TLabel;
    edplano_contas_id: TDBEdit;
    lbconta_origem_id: TLabel;
    edconta_origem_id: TDBEdit;
    lbconta_destino_id: TLabel;
    edconta_destino_id: TDBEdit;
    lbfuncionario_id: TLabel;
    edfuncionario_id: TDBEdit;
    lbdocumento: TLabel;
    eddocumento: TDBEdit;
    lbhistorico: TLabel;
    edhistorico: TDBEdit;
    lblancamento_credito: TLabel;
    edlancamento_credito: TDBEdit;
    lblancamento_estorno: TLabel;
    edlancamento_estorno: TDBEdit;
    lblancamento_prazo: TLabel;
    edlancamento_prazo: TDBEdit;
    lbdata_emissao: TLabel;
    eddata_emissao: TDBEdit;
    lbdata_vencimento: TLabel;
    eddata_vencimento: TDBEdit;
    lbdata_pagamento: TLabel;
    eddata_pagamento: TDBEdit;
    lbvalor: TLabel;
    edvalor: TDBEdit;
    lbobservacoes: TLabel;
    edobservacoes: TDBEdit;
    lbsaldo_inicial_origem: TLabel;
    edsaldo_inicial_origem: TDBEdit;
    lbsaldo_inicial_destino: TLabel;
    edsaldo_inicial_destino: TDBEdit;
    lbcodigo_interno: TLabel;
    edcodigo_interno: TDBEdit;
    lbexcluido: TLabel;
    edexcluido: TDBEdit;
    lbinclusao: TLabel;
    edinclusao: TDBEdit;
    lbalteracao: TLabel;
    edalteracao: TDBEdit;
    lbexclusao: TLabel;
    edexclusao: TDBEdit;
    XDataClientLancamentosGet: TXDataWebClient;
    XDataClientLancamentosDelete: TXDataWebClient;
    LancamentosDataset: TXDataWebDataSet;
    LancamentosDatasetid: TIntegerField;
    LancamentosDatasetaliado_id: TIntegerField;
    LancamentosDatasetdata_base_id: TIntegerField;
    LancamentosDatasetcliente_id: TIntegerField;
    LancamentosDatasetfornecedor_id: TIntegerField;
    LancamentosDatasetmodalidade_id: TIntegerField;
    LancamentosDatasetplano_contas_id: TIntegerField;
    LancamentosDatasetconta_origem_id: TIntegerField;
    LancamentosDatasetconta_destino_id: TIntegerField;
    LancamentosDatasetfuncionario_id: TIntegerField;
    LancamentosDatasetdocumento: TStringField;
    LancamentosDatasethistorico: TStringField;
    LancamentosDatasetlancamento_credito: TBooleanField;
    LancamentosDatasetlancamento_estorno: TBooleanField;
    LancamentosDatasetlancamento_prazo: TBooleanField;
    LancamentosDatasetdata_emissao: TDateTimeField;
    LancamentosDatasetdata_vencimento: TDateTimeField;
    LancamentosDatasetdata_pagamento: TDateTimeField;
    LancamentosDatasetvalor: TFloatField;
    LancamentosDatasetobservacoes: TStringField;
    LancamentosDatasetsaldo_inicial_origem: TFloatField;
    LancamentosDatasetsaldo_inicial_destino: TFloatField;
    LancamentosDatasetcodigo_interno: TIntegerField;
    LancamentosDatasetexcluido: TBooleanField;
    LancamentosDatasetinclusao: TDateTimeField;
    LancamentosDatasetalteracao: TDateTimeField;
    LancamentosDatasetexclusao: TDateTimeField;
    procedure btCloseMessageClick(Sender: TObject);
    procedure btCancelClick(Sender: TObject);
    procedure btSaveClick(Sender: TObject);
    procedure btDeleteClick(Sender: TObject);
    procedure XDataClientLancamentosGetLoad(Response: TXDataClientResponse);
    procedure XDataClientLancamentosDeleteLoad(Response: TXDataClientResponse);
    procedure XDataClientLancamentosDeleteError(Error: TXDataClientError);
    procedure LancamentosDatasetAfterApplyUpdates(Sender: TDataSet;
      Info: TResolveResults);
    procedure WebFormCreate(Sender: TObject);
  private
    FId: JSValue;
    FShowListProc: TListProc;
    procedure InsertEntity;
    procedure LoadEntity;
    procedure ShowNotification(Notification: string);
    procedure HiddenNotification;
    class function InternalCreateForm(AElementID: string;
      AShowListProc: TListProc; AInserting: Boolean; AId: JSValue): TForm; overload;
  protected
    FInserting: Boolean;
  public
    class function CreateForm(AElementID: string;
      AShowListProc: TListProc; AId: JSValue): TForm; overload;
  protected procedure LoadDFMValues; override; end;

var
  FViewLancamentosEdit: TFViewLancamentosEdit;

implementation

uses
  ConnectionModule;

{$R *.dfm}

{ TFViewLancamentosEdit }

procedure TFViewLancamentosEdit.btSaveClick(Sender: TObject);
begin
  if LancamentosDataset.State in dsEditModes then
  begin
        LancamentosDataset.Post;
    LancamentosDataset.ApplyUpdates;
  end
  else
    FShowListProc;
end;

procedure TFViewLancamentosEdit.btDeleteClick(Sender: TObject);
begin
  if LancamentosDataset.State in dsEditModes then
    LancamentosDataset.Post;
  XDataClientLancamentosDelete.Delete(LancamentosDataset.EntitySetName,
    TJSObject(LancamentosDataset.CurrentData));
end;


class function TFViewLancamentosEdit.CreateForm(AElementID: string;
  AShowListProc: TListProc; AId: JSValue): TForm;
var
  Inserting: Boolean;
begin
  Inserting := isNull(AId);
  Result := InternalCreateForm(AElementID, AShowListProc, Inserting, AId);
end;

procedure TFViewLancamentosEdit.HiddenNotification;
begin
  pnlMessage.ElementHandle.hidden := True;
end;

procedure TFViewLancamentosEdit.InsertEntity;
begin
  LancamentosDataset.Close;
  LancamentosDataset.SetJsonData('{}');
  LancamentosDataset.Open;
  LancamentosDataset.Insert;
end;

class function TFViewLancamentosEdit.InternalCreateForm(AElementID: string;
  AShowListProc: TListProc; AInserting: Boolean; AId: JSValue): TForm;

  procedure AfterCreate(AForm: TObject);
  begin
    TFViewLancamentosEdit(AForm).FInserting := AInserting;
    TFViewLancamentosEdit(AForm).FId := AId;
    TFViewLancamentosEdit(AForm).FShowListProc := AShowListProc;
    if AInserting then
      TFViewLancamentosEdit(AForm).InsertEntity
    else
      TFViewLancamentosEdit(AForm).LoadEntity;
    TFViewLancamentosEdit(AForm).btDelete.Enabled := not AInserting;
  end;

begin
  Application.CreateForm(TFViewLancamentosEdit, AElementID, Result, @AfterCreate);
end;

procedure TFViewLancamentosEdit.LoadEntity;
var
  QueryString: string;
begin
  QueryString := TCrudUtils.GetEntityGetQueryString(
    LancamentosDataset.Connection.Model.DefaultSchema.FindEntityType(
      LancamentosDataset.EntitySetName
    )
  );
  XDataClientLancamentosGet.Get(LancamentosDataset.EntitySetName, QueryString, FId);
end;

procedure TFViewLancamentosEdit.ShowNotification(Notification: string);
begin
  lbMessage.Caption := Notification;
  pnlMessage.ElementHandle.hidden := False;
end;

procedure TFViewLancamentosEdit.btCloseMessageClick(Sender: TObject);
begin
  HiddenNotification;
end;

procedure TFViewLancamentosEdit.WebFormCreate(Sender: TObject);
begin
  HiddenNotification;
end;

procedure TFViewLancamentosEdit.XDataClientLancamentosGetLoad(Response: TXDataClientResponse);
begin
  LancamentosDataset.Close;
  LancamentosDataset.SetJsonData(Response.Result);
  LancamentosDataset.Open;
  
  LancamentosDataset.Edit;  
end;

procedure TFViewLancamentosEdit.XDataClientLancamentosDeleteError(
  Error: TXDataClientError);
begin
  ShowNotification(Error.ErrorMessage);
end;

procedure TFViewLancamentosEdit.XDataClientLancamentosDeleteLoad(
  Response: TXDataClientResponse);
begin
  FShowListProc;
end;

procedure TFViewLancamentosEdit.LancamentosDatasetAfterApplyUpdates(Sender: TDataSet;
  Info: TResolveResults);
var
  I: integer;
  ResolveInfo: TResolveInfo;
begin
  for I := 0 to Length(Info.Records) - 1 do
  begin
    ResolveInfo := Info.Records[I];
//    if ResolveInfo.ResolveStatus = TResolveStatus.rsResolveFailed then
    if ResolveInfo.Error <> '' then
    begin
      ShowNotification(ResolveInfo.Error);
      Exit;
    end;
  end;
  FShowListProc;
end;

procedure TFViewLancamentosEdit.btCancelClick(Sender: TObject);
begin
  FShowListProc;
end;

procedure TFViewLancamentosEdit.LoadDFMValues;
begin
  inherited LoadDFMValues;

  pnlMessage := TPanel.Create('view.lancamentos.form.message');
  lbMessage := TLabel.Create('view.lancamentos.form.message.label');
  btCloseMessage := TButton.Create('view.lancamentos.form.message.button');
  btCancel := TButton.Create('view.lancamentos.form.btBack');
  btSave := TButton.Create('view.lancamentos.form.btSave');
  btDelete := TButton.Create('view.lancamentos.form.btDelete');
  lbid := TLabel.Create('view.lancamentos.form.lbid');
  edid := TDBEdit.Create('view.lancamentos.form.edid');
  lbaliado_id := TLabel.Create('view.lancamentos.form.lbaliado_id');
  edaliado_id := TDBEdit.Create('view.lancamentos.form.edaliado_id');
  lbdata_base_id := TLabel.Create('view.lancamentos.form.lbdata_base_id');
  eddata_base_id := TDBEdit.Create('view.lancamentos.form.eddata_base_id');
  lbcliente_id := TLabel.Create('view.lancamentos.form.lbcliente_id');
  edcliente_id := TDBEdit.Create('view.lancamentos.form.edcliente_id');
  lbfornecedor_id := TLabel.Create('view.lancamentos.form.lbfornecedor_id');
  edfornecedor_id := TDBEdit.Create('view.lancamentos.form.edfornecedor_id');
  lbmodalidade_id := TLabel.Create('view.lancamentos.form.lbmodalidade_id');
  edmodalidade_id := TDBEdit.Create('view.lancamentos.form.edmodalidade_id');
  lbplano_contas_id := TLabel.Create('view.lancamentos.form.lbplano_contas_id');
  edplano_contas_id := TDBEdit.Create('view.lancamentos.form.edplano_contas_id');
  lbconta_origem_id := TLabel.Create('view.lancamentos.form.lbconta_origem_id');
  edconta_origem_id := TDBEdit.Create('view.lancamentos.form.edconta_origem_id');
  lbconta_destino_id := TLabel.Create('view.lancamentos.form.lbconta_destino_id');
  edconta_destino_id := TDBEdit.Create('view.lancamentos.form.edconta_destino_id');
  lbfuncionario_id := TLabel.Create('view.lancamentos.form.lbfuncionario_id');
  edfuncionario_id := TDBEdit.Create('view.lancamentos.form.edfuncionario_id');
  lbdocumento := TLabel.Create('view.lancamentos.form.lbdocumento');
  eddocumento := TDBEdit.Create('view.lancamentos.form.eddocumento');
  lbhistorico := TLabel.Create('view.lancamentos.form.lbhistorico');
  edhistorico := TDBEdit.Create('view.lancamentos.form.edhistorico');
  lblancamento_credito := TLabel.Create('view.lancamentos.form.lblancamento_credito');
  edlancamento_credito := TDBEdit.Create('view.lancamentos.form.edlancamento_credito');
  lblancamento_estorno := TLabel.Create('view.lancamentos.form.lblancamento_estorno');
  edlancamento_estorno := TDBEdit.Create('view.lancamentos.form.edlancamento_estorno');
  lblancamento_prazo := TLabel.Create('view.lancamentos.form.lblancamento_prazo');
  edlancamento_prazo := TDBEdit.Create('view.lancamentos.form.edlancamento_prazo');
  lbdata_emissao := TLabel.Create('view.lancamentos.form.lbdata_emissao');
  eddata_emissao := TDBEdit.Create('view.lancamentos.form.eddata_emissao');
  lbdata_vencimento := TLabel.Create('view.lancamentos.form.lbdata_vencimento');
  eddata_vencimento := TDBEdit.Create('view.lancamentos.form.eddata_vencimento');
  lbdata_pagamento := TLabel.Create('view.lancamentos.form.lbdata_pagamento');
  eddata_pagamento := TDBEdit.Create('view.lancamentos.form.eddata_pagamento');
  lbvalor := TLabel.Create('view.lancamentos.form.lbvalor');
  edvalor := TDBEdit.Create('view.lancamentos.form.edvalor');
  lbobservacoes := TLabel.Create('view.lancamentos.form.lbobservacoes');
  edobservacoes := TDBEdit.Create('view.lancamentos.form.edobservacoes');
  lbsaldo_inicial_origem := TLabel.Create('view.lancamentos.form.lbsaldo_inicial_origem');
  edsaldo_inicial_origem := TDBEdit.Create('view.lancamentos.form.edsaldo_inicial_origem');
  lbsaldo_inicial_destino := TLabel.Create('view.lancamentos.form.lbsaldo_inicial_destino');
  edsaldo_inicial_destino := TDBEdit.Create('view.lancamentos.form.edsaldo_inicial_destino');
  lbcodigo_interno := TLabel.Create('view.lancamentos.form.lbcodigo_interno');
  edcodigo_interno := TDBEdit.Create('view.lancamentos.form.edcodigo_interno');
  lbexcluido := TLabel.Create('view.lancamentos.form.lbexcluido');
  edexcluido := TDBEdit.Create('view.lancamentos.form.edexcluido');
  lbinclusao := TLabel.Create('view.lancamentos.form.lbinclusao');
  edinclusao := TDBEdit.Create('view.lancamentos.form.edinclusao');
  lbalteracao := TLabel.Create('view.lancamentos.form.lbalteracao');
  edalteracao := TDBEdit.Create('view.lancamentos.form.edalteracao');
  lbexclusao := TLabel.Create('view.lancamentos.form.lbexclusao');
  edexclusao := TDBEdit.Create('view.lancamentos.form.edexclusao');
  DataSource := TDataSource.Create(Self);
  LancamentosDataset := TXDataWebDataSet.Create(Self);
  LancamentosDatasetid := TIntegerField.Create(Self);
  LancamentosDatasetaliado_id := TIntegerField.Create(Self);
  LancamentosDatasetdata_base_id := TIntegerField.Create(Self);
  LancamentosDatasetcliente_id := TIntegerField.Create(Self);
  LancamentosDatasetfornecedor_id := TIntegerField.Create(Self);
  LancamentosDatasetmodalidade_id := TIntegerField.Create(Self);
  LancamentosDatasetplano_contas_id := TIntegerField.Create(Self);
  LancamentosDatasetconta_origem_id := TIntegerField.Create(Self);
  LancamentosDatasetconta_destino_id := TIntegerField.Create(Self);
  LancamentosDatasetfuncionario_id := TIntegerField.Create(Self);
  LancamentosDatasetdocumento := TStringField.Create(Self);
  LancamentosDatasethistorico := TStringField.Create(Self);
  LancamentosDatasetlancamento_credito := TBooleanField.Create(Self);
  LancamentosDatasetlancamento_estorno := TBooleanField.Create(Self);
  LancamentosDatasetlancamento_prazo := TBooleanField.Create(Self);
  LancamentosDatasetdata_emissao := TDateTimeField.Create(Self);
  LancamentosDatasetdata_vencimento := TDateTimeField.Create(Self);
  LancamentosDatasetdata_pagamento := TDateTimeField.Create(Self);
  LancamentosDatasetvalor := TFloatField.Create(Self);
  LancamentosDatasetobservacoes := TStringField.Create(Self);
  LancamentosDatasetsaldo_inicial_origem := TFloatField.Create(Self);
  LancamentosDatasetsaldo_inicial_destino := TFloatField.Create(Self);
  LancamentosDatasetcodigo_interno := TIntegerField.Create(Self);
  LancamentosDatasetexcluido := TBooleanField.Create(Self);
  LancamentosDatasetinclusao := TDateTimeField.Create(Self);
  LancamentosDatasetalteracao := TDateTimeField.Create(Self);
  LancamentosDatasetexclusao := TDateTimeField.Create(Self);
  XDataClientLancamentosGet := TXDataWebClient.Create(Self);
  XDataClientLancamentosDelete := TXDataWebClient.Create(Self);

  pnlMessage.BeforeLoadDFMValues;
  lbMessage.BeforeLoadDFMValues;
  btCloseMessage.BeforeLoadDFMValues;
  btCancel.BeforeLoadDFMValues;
  btSave.BeforeLoadDFMValues;
  btDelete.BeforeLoadDFMValues;
  lbid.BeforeLoadDFMValues;
  edid.BeforeLoadDFMValues;
  lbaliado_id.BeforeLoadDFMValues;
  edaliado_id.BeforeLoadDFMValues;
  lbdata_base_id.BeforeLoadDFMValues;
  eddata_base_id.BeforeLoadDFMValues;
  lbcliente_id.BeforeLoadDFMValues;
  edcliente_id.BeforeLoadDFMValues;
  lbfornecedor_id.BeforeLoadDFMValues;
  edfornecedor_id.BeforeLoadDFMValues;
  lbmodalidade_id.BeforeLoadDFMValues;
  edmodalidade_id.BeforeLoadDFMValues;
  lbplano_contas_id.BeforeLoadDFMValues;
  edplano_contas_id.BeforeLoadDFMValues;
  lbconta_origem_id.BeforeLoadDFMValues;
  edconta_origem_id.BeforeLoadDFMValues;
  lbconta_destino_id.BeforeLoadDFMValues;
  edconta_destino_id.BeforeLoadDFMValues;
  lbfuncionario_id.BeforeLoadDFMValues;
  edfuncionario_id.BeforeLoadDFMValues;
  lbdocumento.BeforeLoadDFMValues;
  eddocumento.BeforeLoadDFMValues;
  lbhistorico.BeforeLoadDFMValues;
  edhistorico.BeforeLoadDFMValues;
  lblancamento_credito.BeforeLoadDFMValues;
  edlancamento_credito.BeforeLoadDFMValues;
  lblancamento_estorno.BeforeLoadDFMValues;
  edlancamento_estorno.BeforeLoadDFMValues;
  lblancamento_prazo.BeforeLoadDFMValues;
  edlancamento_prazo.BeforeLoadDFMValues;
  lbdata_emissao.BeforeLoadDFMValues;
  eddata_emissao.BeforeLoadDFMValues;
  lbdata_vencimento.BeforeLoadDFMValues;
  eddata_vencimento.BeforeLoadDFMValues;
  lbdata_pagamento.BeforeLoadDFMValues;
  eddata_pagamento.BeforeLoadDFMValues;
  lbvalor.BeforeLoadDFMValues;
  edvalor.BeforeLoadDFMValues;
  lbobservacoes.BeforeLoadDFMValues;
  edobservacoes.BeforeLoadDFMValues;
  lbsaldo_inicial_origem.BeforeLoadDFMValues;
  edsaldo_inicial_origem.BeforeLoadDFMValues;
  lbsaldo_inicial_destino.BeforeLoadDFMValues;
  edsaldo_inicial_destino.BeforeLoadDFMValues;
  lbcodigo_interno.BeforeLoadDFMValues;
  edcodigo_interno.BeforeLoadDFMValues;
  lbexcluido.BeforeLoadDFMValues;
  edexcluido.BeforeLoadDFMValues;
  lbinclusao.BeforeLoadDFMValues;
  edinclusao.BeforeLoadDFMValues;
  lbalteracao.BeforeLoadDFMValues;
  edalteracao.BeforeLoadDFMValues;
  lbexclusao.BeforeLoadDFMValues;
  edexclusao.BeforeLoadDFMValues;
  DataSource.BeforeLoadDFMValues;
  LancamentosDataset.BeforeLoadDFMValues;
  LancamentosDatasetid.BeforeLoadDFMValues;
  LancamentosDatasetaliado_id.BeforeLoadDFMValues;
  LancamentosDatasetdata_base_id.BeforeLoadDFMValues;
  LancamentosDatasetcliente_id.BeforeLoadDFMValues;
  LancamentosDatasetfornecedor_id.BeforeLoadDFMValues;
  LancamentosDatasetmodalidade_id.BeforeLoadDFMValues;
  LancamentosDatasetplano_contas_id.BeforeLoadDFMValues;
  LancamentosDatasetconta_origem_id.BeforeLoadDFMValues;
  LancamentosDatasetconta_destino_id.BeforeLoadDFMValues;
  LancamentosDatasetfuncionario_id.BeforeLoadDFMValues;
  LancamentosDatasetdocumento.BeforeLoadDFMValues;
  LancamentosDatasethistorico.BeforeLoadDFMValues;
  LancamentosDatasetlancamento_credito.BeforeLoadDFMValues;
  LancamentosDatasetlancamento_estorno.BeforeLoadDFMValues;
  LancamentosDatasetlancamento_prazo.BeforeLoadDFMValues;
  LancamentosDatasetdata_emissao.BeforeLoadDFMValues;
  LancamentosDatasetdata_vencimento.BeforeLoadDFMValues;
  LancamentosDatasetdata_pagamento.BeforeLoadDFMValues;
  LancamentosDatasetvalor.BeforeLoadDFMValues;
  LancamentosDatasetobservacoes.BeforeLoadDFMValues;
  LancamentosDatasetsaldo_inicial_origem.BeforeLoadDFMValues;
  LancamentosDatasetsaldo_inicial_destino.BeforeLoadDFMValues;
  LancamentosDatasetcodigo_interno.BeforeLoadDFMValues;
  LancamentosDatasetexcluido.BeforeLoadDFMValues;
  LancamentosDatasetinclusao.BeforeLoadDFMValues;
  LancamentosDatasetalteracao.BeforeLoadDFMValues;
  LancamentosDatasetexclusao.BeforeLoadDFMValues;
  XDataClientLancamentosGet.BeforeLoadDFMValues;
  XDataClientLancamentosDelete.BeforeLoadDFMValues;
  try
    Name := 'FViewLancamentosEdit';
    Left := 0;
    Top := 0;
    Width := 593;
    Height := 994;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -11;
    Font.Name := 'Tahoma';
    Font.Style := [];
    TabOrder := 1;
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    pnlMessage.SetParentComponent(Self);
    pnlMessage.Name := 'pnlMessage';
    pnlMessage.Left := 296;
    pnlMessage.Top := 113;
    pnlMessage.Width := 273;
    pnlMessage.Height := 60;
    pnlMessage.BorderColor := clSilver;
    pnlMessage.BorderStyle := bsSingle;
    lbMessage.SetParentComponent(pnlMessage);
    lbMessage.Name := 'lbMessage';
    lbMessage.Left := 16;
    lbMessage.Top := 24;
    lbMessage.Width := 42;
    lbMessage.Height := 13;
    lbMessage.Caption := 'Message';
    lbMessage.Transparent := True;
    btCloseMessage.SetParentComponent(pnlMessage);
    btCloseMessage.Name := 'btCloseMessage';
    btCloseMessage.Left := 248;
    btCloseMessage.Top := 11;
    btCloseMessage.Width := 22;
    btCloseMessage.Height := 25;
    btCloseMessage.Caption := 'x';
    btCloseMessage.TabOrder := 0;
    SetEvent(btCloseMessage, Self, 'OnClick', 'btCloseMessageClick');
    btCancel.SetParentComponent(Self);
    btCancel.Name := 'btCancel';
    btCancel.Left := 126;
    btCancel.Top := 934;
    btCancel.Width := 96;
    btCancel.Height := 25;
    btCancel.Caption := 'Cancel';
    btCancel.TabOrder := 1;
    SetEvent(btCancel, Self, 'OnClick', 'btCancelClick');
    btSave.SetParentComponent(Self);
    btSave.Name := 'btSave';
    btSave.Left := 24;
    btSave.Top := 934;
    btSave.Width := 96;
    btSave.Height := 25;
    btSave.Caption := 'Save';
    btSave.TabOrder := 4;
    SetEvent(btSave, Self, 'OnClick', 'btSaveClick');
    btDelete.SetParentComponent(Self);
    btDelete.Name := 'btDelete';
    btDelete.Left := 305;
    btDelete.Top := 934;
    btDelete.Width := 96;
    btDelete.Height := 25;
    btDelete.Caption := 'Delete';
    btDelete.TabOrder := 5;
    SetEvent(btDelete, Self, 'OnClick', 'btDeleteClick');
    lbid.SetParentComponent(Self);
    lbid.Name := 'lbid';
    lbid.Left := 24;
    lbid.Top := 192;
    lbid.Width := 14;
    lbid.Height := 13;
    lbid.Caption := 'id:';
    lbid.Transparent := True;
    edid.SetParentComponent(Self);
    edid.Name := 'edid';
    edid.Left := 221;
    edid.Top := 189;
    edid.Width := 200;
    edid.Height := 21;
    edid.Enabled := True;
    edid.TabOrder := 6;
    edid.Text := 'edid';
    edid.DataField := 'id';
    edid.DataSource := DataSource;
    lbaliado_id.SetParentComponent(Self);
    lbaliado_id.Name := 'lbaliado_id';
    lbaliado_id.Left := 24;
    lbaliado_id.Top := 219;
    lbaliado_id.Width := 14;
    lbaliado_id.Height := 13;
    lbaliado_id.Caption := 'aliado_id:';
    lbaliado_id.Transparent := True;
    edaliado_id.SetParentComponent(Self);
    edaliado_id.Name := 'edaliado_id';
    edaliado_id.Left := 221;
    edaliado_id.Top := 216;
    edaliado_id.Width := 200;
    edaliado_id.Height := 21;
    edaliado_id.Enabled := True;
    edaliado_id.TabOrder := 7;
    edaliado_id.Text := 'edaliado_id';
    edaliado_id.DataField := 'aliado_id';
    edaliado_id.DataSource := DataSource;
    lbdata_base_id.SetParentComponent(Self);
    lbdata_base_id.Name := 'lbdata_base_id';
    lbdata_base_id.Left := 24;
    lbdata_base_id.Top := 246;
    lbdata_base_id.Width := 14;
    lbdata_base_id.Height := 13;
    lbdata_base_id.Caption := 'data_base_id:';
    lbdata_base_id.Transparent := True;
    eddata_base_id.SetParentComponent(Self);
    eddata_base_id.Name := 'eddata_base_id';
    eddata_base_id.Left := 221;
    eddata_base_id.Top := 243;
    eddata_base_id.Width := 200;
    eddata_base_id.Height := 21;
    eddata_base_id.Enabled := True;
    eddata_base_id.TabOrder := 8;
    eddata_base_id.Text := 'eddata_base_id';
    eddata_base_id.DataField := 'data_base_id';
    eddata_base_id.DataSource := DataSource;
    lbcliente_id.SetParentComponent(Self);
    lbcliente_id.Name := 'lbcliente_id';
    lbcliente_id.Left := 24;
    lbcliente_id.Top := 273;
    lbcliente_id.Width := 14;
    lbcliente_id.Height := 13;
    lbcliente_id.Caption := 'cliente_id:';
    lbcliente_id.Transparent := True;
    edcliente_id.SetParentComponent(Self);
    edcliente_id.Name := 'edcliente_id';
    edcliente_id.Left := 221;
    edcliente_id.Top := 270;
    edcliente_id.Width := 200;
    edcliente_id.Height := 21;
    edcliente_id.Enabled := True;
    edcliente_id.TabOrder := 9;
    edcliente_id.Text := 'edcliente_id';
    edcliente_id.DataField := 'cliente_id';
    edcliente_id.DataSource := DataSource;
    lbfornecedor_id.SetParentComponent(Self);
    lbfornecedor_id.Name := 'lbfornecedor_id';
    lbfornecedor_id.Left := 24;
    lbfornecedor_id.Top := 300;
    lbfornecedor_id.Width := 14;
    lbfornecedor_id.Height := 13;
    lbfornecedor_id.Caption := 'fornecedor_id:';
    lbfornecedor_id.Transparent := True;
    edfornecedor_id.SetParentComponent(Self);
    edfornecedor_id.Name := 'edfornecedor_id';
    edfornecedor_id.Left := 221;
    edfornecedor_id.Top := 297;
    edfornecedor_id.Width := 200;
    edfornecedor_id.Height := 21;
    edfornecedor_id.Enabled := True;
    edfornecedor_id.TabOrder := 10;
    edfornecedor_id.Text := 'edfornecedor_id';
    edfornecedor_id.DataField := 'fornecedor_id';
    edfornecedor_id.DataSource := DataSource;
    lbmodalidade_id.SetParentComponent(Self);
    lbmodalidade_id.Name := 'lbmodalidade_id';
    lbmodalidade_id.Left := 24;
    lbmodalidade_id.Top := 327;
    lbmodalidade_id.Width := 14;
    lbmodalidade_id.Height := 13;
    lbmodalidade_id.Caption := 'modalidade_id:';
    lbmodalidade_id.Transparent := True;
    edmodalidade_id.SetParentComponent(Self);
    edmodalidade_id.Name := 'edmodalidade_id';
    edmodalidade_id.Left := 221;
    edmodalidade_id.Top := 324;
    edmodalidade_id.Width := 200;
    edmodalidade_id.Height := 21;
    edmodalidade_id.Enabled := True;
    edmodalidade_id.TabOrder := 11;
    edmodalidade_id.Text := 'edmodalidade_id';
    edmodalidade_id.DataField := 'modalidade_id';
    edmodalidade_id.DataSource := DataSource;
    lbplano_contas_id.SetParentComponent(Self);
    lbplano_contas_id.Name := 'lbplano_contas_id';
    lbplano_contas_id.Left := 24;
    lbplano_contas_id.Top := 354;
    lbplano_contas_id.Width := 14;
    lbplano_contas_id.Height := 13;
    lbplano_contas_id.Caption := 'plano_contas_id:';
    lbplano_contas_id.Transparent := True;
    edplano_contas_id.SetParentComponent(Self);
    edplano_contas_id.Name := 'edplano_contas_id';
    edplano_contas_id.Left := 221;
    edplano_contas_id.Top := 351;
    edplano_contas_id.Width := 200;
    edplano_contas_id.Height := 21;
    edplano_contas_id.Enabled := True;
    edplano_contas_id.TabOrder := 12;
    edplano_contas_id.Text := 'edplano_contas_id';
    edplano_contas_id.DataField := 'plano_contas_id';
    edplano_contas_id.DataSource := DataSource;
    lbconta_origem_id.SetParentComponent(Self);
    lbconta_origem_id.Name := 'lbconta_origem_id';
    lbconta_origem_id.Left := 24;
    lbconta_origem_id.Top := 381;
    lbconta_origem_id.Width := 14;
    lbconta_origem_id.Height := 13;
    lbconta_origem_id.Caption := 'conta_origem_id:';
    lbconta_origem_id.Transparent := True;
    edconta_origem_id.SetParentComponent(Self);
    edconta_origem_id.Name := 'edconta_origem_id';
    edconta_origem_id.Left := 221;
    edconta_origem_id.Top := 378;
    edconta_origem_id.Width := 200;
    edconta_origem_id.Height := 21;
    edconta_origem_id.Enabled := True;
    edconta_origem_id.TabOrder := 13;
    edconta_origem_id.Text := 'edconta_origem_id';
    edconta_origem_id.DataField := 'conta_origem_id';
    edconta_origem_id.DataSource := DataSource;
    lbconta_destino_id.SetParentComponent(Self);
    lbconta_destino_id.Name := 'lbconta_destino_id';
    lbconta_destino_id.Left := 24;
    lbconta_destino_id.Top := 408;
    lbconta_destino_id.Width := 14;
    lbconta_destino_id.Height := 13;
    lbconta_destino_id.Caption := 'conta_destino_id:';
    lbconta_destino_id.Transparent := True;
    edconta_destino_id.SetParentComponent(Self);
    edconta_destino_id.Name := 'edconta_destino_id';
    edconta_destino_id.Left := 221;
    edconta_destino_id.Top := 405;
    edconta_destino_id.Width := 200;
    edconta_destino_id.Height := 21;
    edconta_destino_id.Enabled := True;
    edconta_destino_id.TabOrder := 14;
    edconta_destino_id.Text := 'edconta_destino_id';
    edconta_destino_id.DataField := 'conta_destino_id';
    edconta_destino_id.DataSource := DataSource;
    lbfuncionario_id.SetParentComponent(Self);
    lbfuncionario_id.Name := 'lbfuncionario_id';
    lbfuncionario_id.Left := 24;
    lbfuncionario_id.Top := 435;
    lbfuncionario_id.Width := 14;
    lbfuncionario_id.Height := 13;
    lbfuncionario_id.Caption := 'funcionario_id:';
    lbfuncionario_id.Transparent := True;
    edfuncionario_id.SetParentComponent(Self);
    edfuncionario_id.Name := 'edfuncionario_id';
    edfuncionario_id.Left := 221;
    edfuncionario_id.Top := 432;
    edfuncionario_id.Width := 200;
    edfuncionario_id.Height := 21;
    edfuncionario_id.Enabled := True;
    edfuncionario_id.TabOrder := 15;
    edfuncionario_id.Text := 'edfuncionario_id';
    edfuncionario_id.DataField := 'funcionario_id';
    edfuncionario_id.DataSource := DataSource;
    lbdocumento.SetParentComponent(Self);
    lbdocumento.Name := 'lbdocumento';
    lbdocumento.Left := 24;
    lbdocumento.Top := 462;
    lbdocumento.Width := 14;
    lbdocumento.Height := 13;
    lbdocumento.Caption := 'documento:';
    lbdocumento.Transparent := True;
    eddocumento.SetParentComponent(Self);
    eddocumento.Name := 'eddocumento';
    eddocumento.Left := 221;
    eddocumento.Top := 459;
    eddocumento.Width := 200;
    eddocumento.Height := 21;
    eddocumento.Enabled := True;
    eddocumento.TabOrder := 16;
    eddocumento.Text := 'eddocumento';
    eddocumento.DataField := 'documento';
    eddocumento.DataSource := DataSource;
    lbhistorico.SetParentComponent(Self);
    lbhistorico.Name := 'lbhistorico';
    lbhistorico.Left := 24;
    lbhistorico.Top := 489;
    lbhistorico.Width := 14;
    lbhistorico.Height := 13;
    lbhistorico.Caption := 'historico:';
    lbhistorico.Transparent := True;
    edhistorico.SetParentComponent(Self);
    edhistorico.Name := 'edhistorico';
    edhistorico.Left := 221;
    edhistorico.Top := 486;
    edhistorico.Width := 200;
    edhistorico.Height := 21;
    edhistorico.Enabled := True;
    edhistorico.TabOrder := 17;
    edhistorico.Text := 'edhistorico';
    edhistorico.DataField := 'historico';
    edhistorico.DataSource := DataSource;
    lblancamento_credito.SetParentComponent(Self);
    lblancamento_credito.Name := 'lblancamento_credito';
    lblancamento_credito.Left := 24;
    lblancamento_credito.Top := 516;
    lblancamento_credito.Width := 14;
    lblancamento_credito.Height := 13;
    lblancamento_credito.Caption := 'lancamento_credito:';
    lblancamento_credito.Transparent := True;
    edlancamento_credito.SetParentComponent(Self);
    edlancamento_credito.Name := 'edlancamento_credito';
    edlancamento_credito.Left := 221;
    edlancamento_credito.Top := 513;
    edlancamento_credito.Width := 200;
    edlancamento_credito.Height := 21;
    edlancamento_credito.Enabled := True;
    edlancamento_credito.TabOrder := 18;
    edlancamento_credito.Text := 'edlancamento_credito';
    edlancamento_credito.DataField := 'lancamento_credito';
    edlancamento_credito.DataSource := DataSource;
    lblancamento_estorno.SetParentComponent(Self);
    lblancamento_estorno.Name := 'lblancamento_estorno';
    lblancamento_estorno.Left := 24;
    lblancamento_estorno.Top := 543;
    lblancamento_estorno.Width := 14;
    lblancamento_estorno.Height := 13;
    lblancamento_estorno.Caption := 'lancamento_estorno:';
    lblancamento_estorno.Transparent := True;
    edlancamento_estorno.SetParentComponent(Self);
    edlancamento_estorno.Name := 'edlancamento_estorno';
    edlancamento_estorno.Left := 221;
    edlancamento_estorno.Top := 540;
    edlancamento_estorno.Width := 200;
    edlancamento_estorno.Height := 21;
    edlancamento_estorno.Enabled := True;
    edlancamento_estorno.TabOrder := 19;
    edlancamento_estorno.Text := 'edlancamento_estorno';
    edlancamento_estorno.DataField := 'lancamento_estorno';
    edlancamento_estorno.DataSource := DataSource;
    lblancamento_prazo.SetParentComponent(Self);
    lblancamento_prazo.Name := 'lblancamento_prazo';
    lblancamento_prazo.Left := 24;
    lblancamento_prazo.Top := 570;
    lblancamento_prazo.Width := 14;
    lblancamento_prazo.Height := 13;
    lblancamento_prazo.Caption := 'lancamento_prazo:';
    lblancamento_prazo.Transparent := True;
    edlancamento_prazo.SetParentComponent(Self);
    edlancamento_prazo.Name := 'edlancamento_prazo';
    edlancamento_prazo.Left := 221;
    edlancamento_prazo.Top := 567;
    edlancamento_prazo.Width := 200;
    edlancamento_prazo.Height := 21;
    edlancamento_prazo.Enabled := True;
    edlancamento_prazo.TabOrder := 20;
    edlancamento_prazo.Text := 'edlancamento_prazo';
    edlancamento_prazo.DataField := 'lancamento_prazo';
    edlancamento_prazo.DataSource := DataSource;
    lbdata_emissao.SetParentComponent(Self);
    lbdata_emissao.Name := 'lbdata_emissao';
    lbdata_emissao.Left := 24;
    lbdata_emissao.Top := 597;
    lbdata_emissao.Width := 14;
    lbdata_emissao.Height := 13;
    lbdata_emissao.Caption := 'data_emissao:';
    lbdata_emissao.Transparent := True;
    eddata_emissao.SetParentComponent(Self);
    eddata_emissao.Name := 'eddata_emissao';
    eddata_emissao.Left := 221;
    eddata_emissao.Top := 594;
    eddata_emissao.Width := 200;
    eddata_emissao.Height := 21;
    eddata_emissao.Enabled := True;
    eddata_emissao.TabOrder := 21;
    eddata_emissao.Text := 'eddata_emissao';
    eddata_emissao.DataField := 'data_emissao';
    eddata_emissao.DataSource := DataSource;
    lbdata_vencimento.SetParentComponent(Self);
    lbdata_vencimento.Name := 'lbdata_vencimento';
    lbdata_vencimento.Left := 24;
    lbdata_vencimento.Top := 624;
    lbdata_vencimento.Width := 14;
    lbdata_vencimento.Height := 13;
    lbdata_vencimento.Caption := 'data_vencimento:';
    lbdata_vencimento.Transparent := True;
    eddata_vencimento.SetParentComponent(Self);
    eddata_vencimento.Name := 'eddata_vencimento';
    eddata_vencimento.Left := 221;
    eddata_vencimento.Top := 621;
    eddata_vencimento.Width := 200;
    eddata_vencimento.Height := 21;
    eddata_vencimento.Enabled := True;
    eddata_vencimento.TabOrder := 22;
    eddata_vencimento.Text := 'eddata_vencimento';
    eddata_vencimento.DataField := 'data_vencimento';
    eddata_vencimento.DataSource := DataSource;
    lbdata_pagamento.SetParentComponent(Self);
    lbdata_pagamento.Name := 'lbdata_pagamento';
    lbdata_pagamento.Left := 24;
    lbdata_pagamento.Top := 651;
    lbdata_pagamento.Width := 14;
    lbdata_pagamento.Height := 13;
    lbdata_pagamento.Caption := 'data_pagamento:';
    lbdata_pagamento.Transparent := True;
    eddata_pagamento.SetParentComponent(Self);
    eddata_pagamento.Name := 'eddata_pagamento';
    eddata_pagamento.Left := 221;
    eddata_pagamento.Top := 648;
    eddata_pagamento.Width := 200;
    eddata_pagamento.Height := 21;
    eddata_pagamento.Enabled := True;
    eddata_pagamento.TabOrder := 23;
    eddata_pagamento.Text := 'eddata_pagamento';
    eddata_pagamento.DataField := 'data_pagamento';
    eddata_pagamento.DataSource := DataSource;
    lbvalor.SetParentComponent(Self);
    lbvalor.Name := 'lbvalor';
    lbvalor.Left := 24;
    lbvalor.Top := 678;
    lbvalor.Width := 14;
    lbvalor.Height := 13;
    lbvalor.Caption := 'valor:';
    lbvalor.Transparent := True;
    edvalor.SetParentComponent(Self);
    edvalor.Name := 'edvalor';
    edvalor.Left := 221;
    edvalor.Top := 675;
    edvalor.Width := 200;
    edvalor.Height := 21;
    edvalor.Enabled := True;
    edvalor.TabOrder := 24;
    edvalor.Text := 'edvalor';
    edvalor.DataField := 'valor';
    edvalor.DataSource := DataSource;
    lbobservacoes.SetParentComponent(Self);
    lbobservacoes.Name := 'lbobservacoes';
    lbobservacoes.Left := 24;
    lbobservacoes.Top := 705;
    lbobservacoes.Width := 14;
    lbobservacoes.Height := 13;
    lbobservacoes.Caption := 'observacoes:';
    lbobservacoes.Transparent := True;
    edobservacoes.SetParentComponent(Self);
    edobservacoes.Name := 'edobservacoes';
    edobservacoes.Left := 221;
    edobservacoes.Top := 702;
    edobservacoes.Width := 200;
    edobservacoes.Height := 21;
    edobservacoes.Enabled := True;
    edobservacoes.TabOrder := 25;
    edobservacoes.Text := 'edobservacoes';
    edobservacoes.DataField := 'observacoes';
    edobservacoes.DataSource := DataSource;
    lbsaldo_inicial_origem.SetParentComponent(Self);
    lbsaldo_inicial_origem.Name := 'lbsaldo_inicial_origem';
    lbsaldo_inicial_origem.Left := 24;
    lbsaldo_inicial_origem.Top := 732;
    lbsaldo_inicial_origem.Width := 14;
    lbsaldo_inicial_origem.Height := 13;
    lbsaldo_inicial_origem.Caption := 'saldo_inicial_origem:';
    lbsaldo_inicial_origem.Transparent := True;
    edsaldo_inicial_origem.SetParentComponent(Self);
    edsaldo_inicial_origem.Name := 'edsaldo_inicial_origem';
    edsaldo_inicial_origem.Left := 221;
    edsaldo_inicial_origem.Top := 729;
    edsaldo_inicial_origem.Width := 200;
    edsaldo_inicial_origem.Height := 21;
    edsaldo_inicial_origem.Enabled := True;
    edsaldo_inicial_origem.TabOrder := 26;
    edsaldo_inicial_origem.Text := 'edsaldo_inicial_origem';
    edsaldo_inicial_origem.DataField := 'saldo_inicial_origem';
    edsaldo_inicial_origem.DataSource := DataSource;
    lbsaldo_inicial_destino.SetParentComponent(Self);
    lbsaldo_inicial_destino.Name := 'lbsaldo_inicial_destino';
    lbsaldo_inicial_destino.Left := 24;
    lbsaldo_inicial_destino.Top := 759;
    lbsaldo_inicial_destino.Width := 14;
    lbsaldo_inicial_destino.Height := 13;
    lbsaldo_inicial_destino.Caption := 'saldo_inicial_destino:';
    lbsaldo_inicial_destino.Transparent := True;
    edsaldo_inicial_destino.SetParentComponent(Self);
    edsaldo_inicial_destino.Name := 'edsaldo_inicial_destino';
    edsaldo_inicial_destino.Left := 221;
    edsaldo_inicial_destino.Top := 756;
    edsaldo_inicial_destino.Width := 200;
    edsaldo_inicial_destino.Height := 21;
    edsaldo_inicial_destino.Enabled := True;
    edsaldo_inicial_destino.TabOrder := 27;
    edsaldo_inicial_destino.Text := 'edsaldo_inicial_destino';
    edsaldo_inicial_destino.DataField := 'saldo_inicial_destino';
    edsaldo_inicial_destino.DataSource := DataSource;
    lbcodigo_interno.SetParentComponent(Self);
    lbcodigo_interno.Name := 'lbcodigo_interno';
    lbcodigo_interno.Left := 24;
    lbcodigo_interno.Top := 786;
    lbcodigo_interno.Width := 14;
    lbcodigo_interno.Height := 13;
    lbcodigo_interno.Caption := 'codigo_interno:';
    lbcodigo_interno.Transparent := True;
    edcodigo_interno.SetParentComponent(Self);
    edcodigo_interno.Name := 'edcodigo_interno';
    edcodigo_interno.Left := 221;
    edcodigo_interno.Top := 783;
    edcodigo_interno.Width := 200;
    edcodigo_interno.Height := 21;
    edcodigo_interno.Enabled := True;
    edcodigo_interno.TabOrder := 28;
    edcodigo_interno.Text := 'edcodigo_interno';
    edcodigo_interno.DataField := 'codigo_interno';
    edcodigo_interno.DataSource := DataSource;
    lbexcluido.SetParentComponent(Self);
    lbexcluido.Name := 'lbexcluido';
    lbexcluido.Left := 24;
    lbexcluido.Top := 813;
    lbexcluido.Width := 14;
    lbexcluido.Height := 13;
    lbexcluido.Caption := 'excluido:';
    lbexcluido.Transparent := True;
    edexcluido.SetParentComponent(Self);
    edexcluido.Name := 'edexcluido';
    edexcluido.Left := 221;
    edexcluido.Top := 810;
    edexcluido.Width := 200;
    edexcluido.Height := 21;
    edexcluido.Enabled := True;
    edexcluido.TabOrder := 29;
    edexcluido.Text := 'edexcluido';
    edexcluido.DataField := 'excluido';
    edexcluido.DataSource := DataSource;
    lbinclusao.SetParentComponent(Self);
    lbinclusao.Name := 'lbinclusao';
    lbinclusao.Left := 24;
    lbinclusao.Top := 840;
    lbinclusao.Width := 14;
    lbinclusao.Height := 13;
    lbinclusao.Caption := 'inclusao:';
    lbinclusao.Transparent := True;
    edinclusao.SetParentComponent(Self);
    edinclusao.Name := 'edinclusao';
    edinclusao.Left := 221;
    edinclusao.Top := 837;
    edinclusao.Width := 200;
    edinclusao.Height := 21;
    edinclusao.Enabled := True;
    edinclusao.TabOrder := 30;
    edinclusao.Text := 'edinclusao';
    edinclusao.DataField := 'inclusao';
    edinclusao.DataSource := DataSource;
    lbalteracao.SetParentComponent(Self);
    lbalteracao.Name := 'lbalteracao';
    lbalteracao.Left := 24;
    lbalteracao.Top := 867;
    lbalteracao.Width := 14;
    lbalteracao.Height := 13;
    lbalteracao.Caption := 'alteracao:';
    lbalteracao.Transparent := True;
    edalteracao.SetParentComponent(Self);
    edalteracao.Name := 'edalteracao';
    edalteracao.Left := 221;
    edalteracao.Top := 864;
    edalteracao.Width := 200;
    edalteracao.Height := 21;
    edalteracao.Enabled := True;
    edalteracao.TabOrder := 31;
    edalteracao.Text := 'edalteracao';
    edalteracao.DataField := 'alteracao';
    edalteracao.DataSource := DataSource;
    lbexclusao.SetParentComponent(Self);
    lbexclusao.Name := 'lbexclusao';
    lbexclusao.Left := 24;
    lbexclusao.Top := 894;
    lbexclusao.Width := 14;
    lbexclusao.Height := 13;
    lbexclusao.Caption := 'exclusao:';
    lbexclusao.Transparent := True;
    edexclusao.SetParentComponent(Self);
    edexclusao.Name := 'edexclusao';
    edexclusao.Left := 221;
    edexclusao.Top := 891;
    edexclusao.Width := 200;
    edexclusao.Height := 21;
    edexclusao.Enabled := True;
    edexclusao.TabOrder := 32;
    edexclusao.Text := 'edexclusao';
    edexclusao.DataField := 'exclusao';
    edexclusao.DataSource := DataSource;
    DataSource.SetParentComponent(Self);
    DataSource.Name := 'DataSource';
    DataSource.DataSet := LancamentosDataset;
    DataSource.Left := 176;
    DataSource.Top := 56;
    LancamentosDataset.SetParentComponent(Self);
    LancamentosDataset.Name := 'LancamentosDataset';
    LancamentosDataset.AfterApplyUpdates := LancamentosDatasetAfterApplyUpdates;
    LancamentosDataset.EntitySetName := 'Lancamentos';
    LancamentosDataset.Connection := DMConnection.ApiConnection;
    LancamentosDataset.Left := 176;
    LancamentosDataset.Top := 8;
    LancamentosDatasetid.SetParentComponent(LancamentosDataset);
    LancamentosDatasetid.Name := 'LancamentosDatasetid';
    LancamentosDatasetid.FieldName := 'id';
    LancamentosDatasetid.Required := True;
    LancamentosDatasetaliado_id.SetParentComponent(LancamentosDataset);
    LancamentosDatasetaliado_id.Name := 'LancamentosDatasetaliado_id';
    LancamentosDatasetaliado_id.FieldName := 'aliado_id';
    LancamentosDatasetaliado_id.Required := True;
    LancamentosDatasetdata_base_id.SetParentComponent(LancamentosDataset);
    LancamentosDatasetdata_base_id.Name := 'LancamentosDatasetdata_base_id';
    LancamentosDatasetdata_base_id.FieldName := 'data_base_id';
    LancamentosDatasetdata_base_id.Required := True;
    LancamentosDatasetcliente_id.SetParentComponent(LancamentosDataset);
    LancamentosDatasetcliente_id.Name := 'LancamentosDatasetcliente_id';
    LancamentosDatasetcliente_id.FieldName := 'cliente_id';
    LancamentosDatasetcliente_id.Required := False;
    LancamentosDatasetfornecedor_id.SetParentComponent(LancamentosDataset);
    LancamentosDatasetfornecedor_id.Name := 'LancamentosDatasetfornecedor_id';
    LancamentosDatasetfornecedor_id.FieldName := 'fornecedor_id';
    LancamentosDatasetfornecedor_id.Required := False;
    LancamentosDatasetmodalidade_id.SetParentComponent(LancamentosDataset);
    LancamentosDatasetmodalidade_id.Name := 'LancamentosDatasetmodalidade_id';
    LancamentosDatasetmodalidade_id.FieldName := 'modalidade_id';
    LancamentosDatasetmodalidade_id.Required := True;
    LancamentosDatasetplano_contas_id.SetParentComponent(LancamentosDataset);
    LancamentosDatasetplano_contas_id.Name := 'LancamentosDatasetplano_contas_id';
    LancamentosDatasetplano_contas_id.FieldName := 'plano_contas_id';
    LancamentosDatasetplano_contas_id.Required := True;
    LancamentosDatasetconta_origem_id.SetParentComponent(LancamentosDataset);
    LancamentosDatasetconta_origem_id.Name := 'LancamentosDatasetconta_origem_id';
    LancamentosDatasetconta_origem_id.FieldName := 'conta_origem_id';
    LancamentosDatasetconta_origem_id.Required := True;
    LancamentosDatasetconta_destino_id.SetParentComponent(LancamentosDataset);
    LancamentosDatasetconta_destino_id.Name := 'LancamentosDatasetconta_destino_id';
    LancamentosDatasetconta_destino_id.FieldName := 'conta_destino_id';
    LancamentosDatasetconta_destino_id.Required := False;
    LancamentosDatasetfuncionario_id.SetParentComponent(LancamentosDataset);
    LancamentosDatasetfuncionario_id.Name := 'LancamentosDatasetfuncionario_id';
    LancamentosDatasetfuncionario_id.FieldName := 'funcionario_id';
    LancamentosDatasetfuncionario_id.Required := False;
    LancamentosDatasetdocumento.SetParentComponent(LancamentosDataset);
    LancamentosDatasetdocumento.Name := 'LancamentosDatasetdocumento';
    LancamentosDatasetdocumento.FieldName := 'documento';
    LancamentosDatasetdocumento.Required := False;
    LancamentosDatasetdocumento.Size := 255;
    LancamentosDatasethistorico.SetParentComponent(LancamentosDataset);
    LancamentosDatasethistorico.Name := 'LancamentosDatasethistorico';
    LancamentosDatasethistorico.FieldName := 'historico';
    LancamentosDatasethistorico.Required := True;
    LancamentosDatasethistorico.Size := 255;
    LancamentosDatasetlancamento_credito.SetParentComponent(LancamentosDataset);
    LancamentosDatasetlancamento_credito.Name := 'LancamentosDatasetlancamento_credito';
    LancamentosDatasetlancamento_credito.FieldName := 'lancamento_credito';
    LancamentosDatasetlancamento_credito.Required := False;
    LancamentosDatasetlancamento_estorno.SetParentComponent(LancamentosDataset);
    LancamentosDatasetlancamento_estorno.Name := 'LancamentosDatasetlancamento_estorno';
    LancamentosDatasetlancamento_estorno.FieldName := 'lancamento_estorno';
    LancamentosDatasetlancamento_estorno.Required := True;
    LancamentosDatasetlancamento_prazo.SetParentComponent(LancamentosDataset);
    LancamentosDatasetlancamento_prazo.Name := 'LancamentosDatasetlancamento_prazo';
    LancamentosDatasetlancamento_prazo.FieldName := 'lancamento_prazo';
    LancamentosDatasetlancamento_prazo.Required := True;
    LancamentosDatasetdata_emissao.SetParentComponent(LancamentosDataset);
    LancamentosDatasetdata_emissao.Name := 'LancamentosDatasetdata_emissao';
    LancamentosDatasetdata_emissao.FieldName := 'data_emissao';
    LancamentosDatasetdata_emissao.Required := True;
    LancamentosDatasetdata_vencimento.SetParentComponent(LancamentosDataset);
    LancamentosDatasetdata_vencimento.Name := 'LancamentosDatasetdata_vencimento';
    LancamentosDatasetdata_vencimento.FieldName := 'data_vencimento';
    LancamentosDatasetdata_vencimento.Required := True;
    LancamentosDatasetdata_pagamento.SetParentComponent(LancamentosDataset);
    LancamentosDatasetdata_pagamento.Name := 'LancamentosDatasetdata_pagamento';
    LancamentosDatasetdata_pagamento.FieldName := 'data_pagamento';
    LancamentosDatasetdata_pagamento.Required := True;
    LancamentosDatasetvalor.SetParentComponent(LancamentosDataset);
    LancamentosDatasetvalor.Name := 'LancamentosDatasetvalor';
    LancamentosDatasetvalor.FieldName := 'valor';
    LancamentosDatasetvalor.Required := True;
    LancamentosDatasetobservacoes.SetParentComponent(LancamentosDataset);
    LancamentosDatasetobservacoes.Name := 'LancamentosDatasetobservacoes';
    LancamentosDatasetobservacoes.FieldName := 'observacoes';
    LancamentosDatasetobservacoes.Required := False;
    LancamentosDatasetobservacoes.Size := 255;
    LancamentosDatasetsaldo_inicial_origem.SetParentComponent(LancamentosDataset);
    LancamentosDatasetsaldo_inicial_origem.Name := 'LancamentosDatasetsaldo_inicial_origem';
    LancamentosDatasetsaldo_inicial_origem.FieldName := 'saldo_inicial_origem';
    LancamentosDatasetsaldo_inicial_origem.Required := False;
    LancamentosDatasetsaldo_inicial_destino.SetParentComponent(LancamentosDataset);
    LancamentosDatasetsaldo_inicial_destino.Name := 'LancamentosDatasetsaldo_inicial_destino';
    LancamentosDatasetsaldo_inicial_destino.FieldName := 'saldo_inicial_destino';
    LancamentosDatasetsaldo_inicial_destino.Required := False;
    LancamentosDatasetcodigo_interno.SetParentComponent(LancamentosDataset);
    LancamentosDatasetcodigo_interno.Name := 'LancamentosDatasetcodigo_interno';
    LancamentosDatasetcodigo_interno.FieldName := 'codigo_interno';
    LancamentosDatasetcodigo_interno.Required := True;
    LancamentosDatasetexcluido.SetParentComponent(LancamentosDataset);
    LancamentosDatasetexcluido.Name := 'LancamentosDatasetexcluido';
    LancamentosDatasetexcluido.FieldName := 'excluido';
    LancamentosDatasetexcluido.Required := False;
    LancamentosDatasetinclusao.SetParentComponent(LancamentosDataset);
    LancamentosDatasetinclusao.Name := 'LancamentosDatasetinclusao';
    LancamentosDatasetinclusao.FieldName := 'inclusao';
    LancamentosDatasetinclusao.Required := False;
    LancamentosDatasetalteracao.SetParentComponent(LancamentosDataset);
    LancamentosDatasetalteracao.Name := 'LancamentosDatasetalteracao';
    LancamentosDatasetalteracao.FieldName := 'alteracao';
    LancamentosDatasetalteracao.Required := False;
    LancamentosDatasetexclusao.SetParentComponent(LancamentosDataset);
    LancamentosDatasetexclusao.Name := 'LancamentosDatasetexclusao';
    LancamentosDatasetexclusao.FieldName := 'exclusao';
    LancamentosDatasetexclusao.Required := False;
    XDataClientLancamentosGet.SetParentComponent(Self);
    XDataClientLancamentosGet.Name := 'XDataClientLancamentosGet';
    XDataClientLancamentosGet.Connection := DMConnection.ApiConnection;
    SetEvent(XDataClientLancamentosGet, Self, 'OnLoad', 'XDataClientLancamentosGetLoad');
    XDataClientLancamentosGet.Left := 64;
    XDataClientLancamentosGet.Top := 8;
    XDataClientLancamentosDelete.SetParentComponent(Self);
    XDataClientLancamentosDelete.Name := 'XDataClientLancamentosDelete';
    XDataClientLancamentosDelete.Connection := DMConnection.ApiConnection;
    SetEvent(XDataClientLancamentosDelete, Self, 'OnLoad', 'XDataClientLancamentosDeleteLoad');
    SetEvent(XDataClientLancamentosDelete, Self, 'OnError', 'XDataClientLancamentosDeleteError');
    XDataClientLancamentosDelete.Left := 64;
    XDataClientLancamentosDelete.Top := 56;
  finally
    pnlMessage.AfterLoadDFMValues;
    lbMessage.AfterLoadDFMValues;
    btCloseMessage.AfterLoadDFMValues;
    btCancel.AfterLoadDFMValues;
    btSave.AfterLoadDFMValues;
    btDelete.AfterLoadDFMValues;
    lbid.AfterLoadDFMValues;
    edid.AfterLoadDFMValues;
    lbaliado_id.AfterLoadDFMValues;
    edaliado_id.AfterLoadDFMValues;
    lbdata_base_id.AfterLoadDFMValues;
    eddata_base_id.AfterLoadDFMValues;
    lbcliente_id.AfterLoadDFMValues;
    edcliente_id.AfterLoadDFMValues;
    lbfornecedor_id.AfterLoadDFMValues;
    edfornecedor_id.AfterLoadDFMValues;
    lbmodalidade_id.AfterLoadDFMValues;
    edmodalidade_id.AfterLoadDFMValues;
    lbplano_contas_id.AfterLoadDFMValues;
    edplano_contas_id.AfterLoadDFMValues;
    lbconta_origem_id.AfterLoadDFMValues;
    edconta_origem_id.AfterLoadDFMValues;
    lbconta_destino_id.AfterLoadDFMValues;
    edconta_destino_id.AfterLoadDFMValues;
    lbfuncionario_id.AfterLoadDFMValues;
    edfuncionario_id.AfterLoadDFMValues;
    lbdocumento.AfterLoadDFMValues;
    eddocumento.AfterLoadDFMValues;
    lbhistorico.AfterLoadDFMValues;
    edhistorico.AfterLoadDFMValues;
    lblancamento_credito.AfterLoadDFMValues;
    edlancamento_credito.AfterLoadDFMValues;
    lblancamento_estorno.AfterLoadDFMValues;
    edlancamento_estorno.AfterLoadDFMValues;
    lblancamento_prazo.AfterLoadDFMValues;
    edlancamento_prazo.AfterLoadDFMValues;
    lbdata_emissao.AfterLoadDFMValues;
    eddata_emissao.AfterLoadDFMValues;
    lbdata_vencimento.AfterLoadDFMValues;
    eddata_vencimento.AfterLoadDFMValues;
    lbdata_pagamento.AfterLoadDFMValues;
    eddata_pagamento.AfterLoadDFMValues;
    lbvalor.AfterLoadDFMValues;
    edvalor.AfterLoadDFMValues;
    lbobservacoes.AfterLoadDFMValues;
    edobservacoes.AfterLoadDFMValues;
    lbsaldo_inicial_origem.AfterLoadDFMValues;
    edsaldo_inicial_origem.AfterLoadDFMValues;
    lbsaldo_inicial_destino.AfterLoadDFMValues;
    edsaldo_inicial_destino.AfterLoadDFMValues;
    lbcodigo_interno.AfterLoadDFMValues;
    edcodigo_interno.AfterLoadDFMValues;
    lbexcluido.AfterLoadDFMValues;
    edexcluido.AfterLoadDFMValues;
    lbinclusao.AfterLoadDFMValues;
    edinclusao.AfterLoadDFMValues;
    lbalteracao.AfterLoadDFMValues;
    edalteracao.AfterLoadDFMValues;
    lbexclusao.AfterLoadDFMValues;
    edexclusao.AfterLoadDFMValues;
    DataSource.AfterLoadDFMValues;
    LancamentosDataset.AfterLoadDFMValues;
    LancamentosDatasetid.AfterLoadDFMValues;
    LancamentosDatasetaliado_id.AfterLoadDFMValues;
    LancamentosDatasetdata_base_id.AfterLoadDFMValues;
    LancamentosDatasetcliente_id.AfterLoadDFMValues;
    LancamentosDatasetfornecedor_id.AfterLoadDFMValues;
    LancamentosDatasetmodalidade_id.AfterLoadDFMValues;
    LancamentosDatasetplano_contas_id.AfterLoadDFMValues;
    LancamentosDatasetconta_origem_id.AfterLoadDFMValues;
    LancamentosDatasetconta_destino_id.AfterLoadDFMValues;
    LancamentosDatasetfuncionario_id.AfterLoadDFMValues;
    LancamentosDatasetdocumento.AfterLoadDFMValues;
    LancamentosDatasethistorico.AfterLoadDFMValues;
    LancamentosDatasetlancamento_credito.AfterLoadDFMValues;
    LancamentosDatasetlancamento_estorno.AfterLoadDFMValues;
    LancamentosDatasetlancamento_prazo.AfterLoadDFMValues;
    LancamentosDatasetdata_emissao.AfterLoadDFMValues;
    LancamentosDatasetdata_vencimento.AfterLoadDFMValues;
    LancamentosDatasetdata_pagamento.AfterLoadDFMValues;
    LancamentosDatasetvalor.AfterLoadDFMValues;
    LancamentosDatasetobservacoes.AfterLoadDFMValues;
    LancamentosDatasetsaldo_inicial_origem.AfterLoadDFMValues;
    LancamentosDatasetsaldo_inicial_destino.AfterLoadDFMValues;
    LancamentosDatasetcodigo_interno.AfterLoadDFMValues;
    LancamentosDatasetexcluido.AfterLoadDFMValues;
    LancamentosDatasetinclusao.AfterLoadDFMValues;
    LancamentosDatasetalteracao.AfterLoadDFMValues;
    LancamentosDatasetexclusao.AfterLoadDFMValues;
    XDataClientLancamentosGet.AfterLoadDFMValues;
    XDataClientLancamentosDelete.AfterLoadDFMValues;
  end;
end;

end.
